var _excluded = ["children", "variant", "variantDesktop", "variantMobile", "success", "primary", "danger", "info", "secondary", "warning", "light", "ivory", "dangerLight", "dashed", "dashedDesktop", "dashedMobile", "sizeSm", "sizeSmDesktop", "sizeSmMobile", "sizeLg", "sizeLgDesktop", "sizeLgMobile", "sizeInitial", "sizeInitialDesktop", "sizeInitialMobile", "block", "blockDesktop", "blockMobile", "square", "squareDesktop", "squareMobile", "disabled", "className", "additionalClassName", "additionalClassNameDesktop", "additionalClassNameMobile", "type", "asLink", "asNavLink", "to", "onClick", "prettyLoaderProps", "sweetAlertProps", "sweetAlertOnConfirm", "popoverStickOnHoverProps"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';
import { ButtonVariant } from '@collaborator/npm_modules/dist/components/button/button-variant';
import { Size } from '@collaborator/npm_modules/dist/css/size';
import { classNames } from 'components/class-names';
import { useSweetAlert } from '@collaborator/npm_modules/dist/components/sweetAlert/hooks/useSweetAlert';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import { NavLink } from 'components/router/NavLink';
import { Link } from 'components/router/Link';
import { PrettyLoaderReact, PrettyLoaderType } from '@collaborator/npm_modules/dist/components/pretty-loader';
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      variant = _ref.variant,
      variantDesktop = _ref.variantDesktop,
      variantMobile = _ref.variantMobile,
      success = _ref.success,
      primary = _ref.primary,
      danger = _ref.danger,
      info = _ref.info,
      secondary = _ref.secondary,
      warning = _ref.warning,
      light = _ref.light,
      ivory = _ref.ivory,
      dangerLight = _ref.dangerLight,
      dashed = _ref.dashed,
      dashedDesktop = _ref.dashedDesktop,
      dashedMobile = _ref.dashedMobile,
      sizeSm = _ref.sizeSm,
      sizeSmDesktop = _ref.sizeSmDesktop,
      sizeSmMobile = _ref.sizeSmMobile,
      sizeLg = _ref.sizeLg,
      sizeLgDesktop = _ref.sizeLgDesktop,
      sizeLgMobile = _ref.sizeLgMobile,
      sizeInitial = _ref.sizeInitial,
      sizeInitialDesktop = _ref.sizeInitialDesktop,
      sizeInitialMobile = _ref.sizeInitialMobile,
      block = _ref.block,
      blockDesktop = _ref.blockDesktop,
      blockMobile = _ref.blockMobile,
      square = _ref.square,
      squareDesktop = _ref.squareDesktop,
      squareMobile = _ref.squareMobile,
      disabled = _ref.disabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'btn' : _ref$className,
      additionalClassName = _ref.additionalClassName,
      additionalClassNameDesktop = _ref.additionalClassNameDesktop,
      additionalClassNameMobile = _ref.additionalClassNameMobile,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      asLink = _ref.asLink,
      asNavLink = _ref.asNavLink,
      to = _ref.to,
      onClick = _ref.onClick,
      prettyLoaderProps = _ref.prettyLoaderProps,
      sweetAlertProps = _ref.sweetAlertProps,
      sweetAlertOnConfirm = _ref.sweetAlertOnConfirm,
      popoverStickOnHoverProps = _ref.popoverStickOnHoverProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useSweetAlert = useSweetAlert(),
      show = _useSweetAlert.show,
      update = _useSweetAlert.update,
      hide = _useSweetAlert.hide;

  var isDesktop = useMediaIsDesktop();

  var handlerConfirm = function handlerConfirm() {
    update({
      confirmBtnLoading: true
    });
    sweetAlertOnConfirm().then(function () {
      hide();
    });
  };

  var handlerClick = function handlerClick(e) {
    if (onClick) {
      onClick(e);
    }

    if (sweetAlertProps) {
      show(_objectSpread({
        onConfirm: handlerConfirm
      }, sweetAlertProps));
    }
  };

  var getCurrentVariant = function getCurrentVariant() {
    if (isDesktop && variantDesktop) return variantDesktop;
    if (!isDesktop && variantMobile) return variantMobile;
    if (success) return ButtonVariant.success;
    if (primary) return ButtonVariant.primary;
    if (danger) return ButtonVariant.danger;
    if (info) return ButtonVariant.info;
    if (secondary) return ButtonVariant.secondary;
    if (warning) return ButtonVariant.warning;
    if (light) return ButtonVariant.light;
    if (ivory) return ButtonVariant.ivory;
    if (dangerLight) return ButtonVariant.dangerLight;
    return variant;
  };

  var getCurrentSize = function getCurrentSize() {
    if (isDesktop && sizeLgDesktop) return Size.lg;
    if (!isDesktop && sizeLgMobile) return Size.lg;
    if (isDesktop && sizeSmDesktop) return Size.sm;
    if (!isDesktop && sizeSmMobile) return Size.sm;
    if (sizeLg) return Size.lg;
    if (sizeSm) return Size.sm;
    return null;
  };

  var buttonProps = _objectSpread({
    className: classNames([className, _defineProperty({}, "btn-".concat(getCurrentVariant()), getCurrentVariant()), {
      'btn-block': block
    }, {
      'btn-square': square
    }, {
      'btn-sm': getCurrentSize() === Size.sm
    }, {
      'btn-lg': getCurrentSize() === Size.lg
    }, {
      'btn-size-initial': sizeInitial
    }, {
      'btn--dashed': dashed
    }, additionalClassName], [{
      'btn-block': blockDesktop
    }, {
      'btn-square': squareDesktop
    }, {
      'btn-size-initial': sizeInitialDesktop
    }, {
      'btn-dashed': dashedDesktop
    }, additionalClassNameDesktop], [{
      'btn-block': blockMobile
    }, {
      'btn-square': squareMobile
    }, {
      'btn-size-initial': sizeInitialMobile
    }, {
      'btn--dashed': dashedMobile
    }, additionalClassNameMobile]),
    disabled: disabled,
    onClick: handlerClick
  }, props);

  var wrapPopoverStickOnHover = function wrapPopoverStickOnHover(button) {
    if (!popoverStickOnHoverProps) {
      return button;
    }

    return /*#__PURE__*/React.createElement(PopoverStickOnHover, {
      text: popoverStickOnHoverProps.text,
      placement: popoverStickOnHoverProps.placement,
      onExited: popoverStickOnHoverProps.onExited,
      asHtml: popoverStickOnHoverProps.asHtml,
      popoverProps: popoverStickOnHoverProps.popoverProps
    }, /*#__PURE__*/React.createElement("span", null, button));
  };

  var wrapPrettyLoader = function wrapPrettyLoader(button) {
    if (!prettyLoaderProps) {
      return button;
    }

    var config = prettyLoaderProps.config || {};

    if (!config.color) {
      if (getCurrentVariant() === ButtonVariant.primary) {
        config.color = '#858585';
      }
    }

    if (!config.type) {
      if (square) {
        config.type = PrettyLoaderType.circle;
      }
    }

    return /*#__PURE__*/React.createElement(PrettyLoaderReact, {
      isLoading: prettyLoaderProps.isLoading,
      config: config
    }, button);
  };

  if (asLink) {
    return wrapPopoverStickOnHover( /*#__PURE__*/React.createElement(Link, _extends({
      ref: ref,
      to: to
    }, buttonProps), children));
  }

  if (asNavLink) {
    return wrapPopoverStickOnHover( /*#__PURE__*/React.createElement(NavLink, _extends({
      ref: ref,
      to: to
    }, buttonProps), children));
  }

  return wrapPopoverStickOnHover(wrapPrettyLoader( /*#__PURE__*/React.createElement("button", _extends({
    type: type === 'button' ? 'button' : 'submit',
    ref: ref
  }, buttonProps), children)));
});
export { Button };